import { takeLatest, call, put } from "redux-saga/effects";
import {
  FETCH_CANDIDATE_APPLIED_JOBS_REQUEST,
} from "../../actionTypes";

import {
  fetchCandidateAppliedJobsSuccess,
  fetchCandidateAppliedJobsFailure,
} from "./actions";
import AxiosInstance from "../../../services/AxiosInstance";
// Worker saga
function* fetchCandidateAppliedJobsaction(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/jobseeker/fetch_candidate_applied_job", action.payload)
    );
    if (response.data.status) {
      yield put(fetchCandidateAppliedJobsSuccess(response.data));
    } else {
      fetchCandidateAppliedJobsFailure(response.data);
    }
  } catch (error) {
    yield put(
      fetchCandidateAppliedJobsFailure({ status: false, message: error.message })
    );
  }
}

// Watcher saga
function* fetchCandidateAppliedJobsSaga() {
  yield takeLatest(FETCH_CANDIDATE_APPLIED_JOBS_REQUEST, fetchCandidateAppliedJobsaction);
}
export default fetchCandidateAppliedJobsSaga;
